/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface SellType {

        "code"?: number;

        "description"?: string;
    }

}
